import { render, staticRenderFns } from "./OidcSilentRenew.vue?vue&type=template&id=498f780e"
import script from "./OidcSilentRenew.vue?vue&type=script&lang=js"
export * from "./OidcSilentRenew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports